import { PlatformService } from '@core/services/platform.service';
import { CaseMetricsService } from '@products/dmepos/services/case-metrics.service';
import { ServiceLineMetricsService } from '@products/pac/services/service-line-metrics.service';
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@mynexus/mynexus-ui-lib';
import { ProductName } from '@core/constants';

export default (platformService: PlatformService, http: HttpClient, oDataService: ODataService) => {
  switch (platformService.currentProduct.value) {
    case ProductName.DMEPOS_MA:
    case ProductName.DMEPOS_MCD:
      return new CaseMetricsService(platformService, http, oDataService);
    default:
      return new ServiceLineMetricsService(platformService, http, oDataService);
  }
};
